import React,{useState}  from 'react'
import {Box,Typography,Container,Button, Divider} from '@mui/material'
import {useTheme,styled } from '@mui/material/styles'
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowIcon from '@mui/icons-material/ArrowBackRounded';
import CircularProgress from '@mui/material/CircularProgress';
import {IconButton} from "@mui/material"
import {useNavigate} from 'react-router-dom'
import create_template from '../Redux/reducers/create_template'
import { add_template,add_templates} from "../Redux/templatesSlice";
import Header from '../Components/Header'
import CustomDialog from '../Components/CustomDialog'
import useMediaQuery from '@mui/material/useMediaQuery'; 
import UserInput from '../Components/UserInput'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import axios from 'axios'
import Snackbar from '@mui/material/Snackbar'
import GridViewContainer from '../Components/GridViewContainer';
import AutoInput from '../Components/AutoInput';
import MultiInput from '../Components/MultiInput';
import { add_activities,add_activity } from '../Redux/settingSlice';
import dayjs from 'dayjs';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import TimeInput from '../Components/TimeInput';
import DateInput from '../Components/DateInput';
import { AddCard,FormatAlignCenter, AddCircleOutlined, FilePresentOutlined, MicRounded, PeopleAltOutlined } from '@mui/icons-material';
import SectionsDialog from '../Components/SectionsDialog';
import SectionAddView from '../Components/SectionAddView';
import EditorText from '../Components/EditorText';

function generate_id (){

	const c2 = Math.floor(Math.random()*10);
	const c3 = Math.floor(Math.random()*10);
	const c4 = Math.floor(Math.random()*10);
	const c1 = Math.floor(Math.random()*10);
	const c5 = Math.floor(Math.random()*10);
	const c6 = Math.floor(Math.random()*10);
	const c7 = Math.floor(Math.random()*10);
	const c8 = Math.floor(Math.random()*10);
  
	var result = `${c1}`+`${c2}`+`${c3}`+`${c4}`+`${c5}`+`${c6}`+`${c7}`+`${c8}`;
  
  return result
  }

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    width:400,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
    },
  }));

const DuplicateTemplate = ()=>{

	const response_types= ["Job","Exam","Event","Others"]
	const categories = ["IT","RH","Finance","Logistic","Marketing","Management","Entrepreneurship","Health","Mechanic","Electric","Electronic","Others"]
	const levels = ["Beginner","Intermediate","Advanced","Expert"]
    const types = ["Public","Private"]

	const theme = useTheme()
    const template = useSelector(state => state?.templates.template);
	const test = useSelector(state => state?.test.test);
	const [name,setName] = useState(template?.name)
	const [type,setType] = useState(template?.type)
	const [email,setEmail] = useState("")
    const [description, setDescription] = useState(template?.description);
	const [duration, setDuration] = useState(null);
	const [start_date, setStart_date] = useState(template?.start_date);
	const [start_moment, setStart_moment] = useState(null);
	const [level, setLevel] = useState(template?.level);
	const navigate = useNavigate()
	const [lang, setLang] = useState(template?.language);
	const [loading, setLoading] = useState(false);
	const [open, setOpen] = React.useState(false);
	const [response_type, setResponse_type] = React.useState("Any");
	const [isInfo, setIsInfo] = React.useState(true);
	const [isPart, setIsPart] = React.useState(false);
	const [isSend, setIsSend] = React.useState(false);
	const [showDialog, setShowDialog] = React.useState(false);
    const [showSections, setShowSections] = React.useState(false);
	const [isNext, setIsNext] = React.useState(false);
	const [message, setMessage] = React.useState("");
    const [visible_type, setVisible_type] = React.useState(template?.visibility);
    const [progress, setProgress] = React.useState(10);
	const [last_name, setLast_name] = React.useState("");
	const [first_name, setFirst_name] = React.useState("");
	const [category, setCategory] = React.useState("RH");
	const [participants, setParticipants] = React.useState([]);
    const [sections, setSections] = React.useState(template?.sections);
	const user = useSelector(state => state?.auth.user);
	const templates = useSelector(state => state?.templates.templates);
	const [trans, setTrans] = React.useState(false);
	const [transcript, setTranscript] = React.useState('');
	const recorder = React.useRef(null)
	const [isRecording, setIsRecording] = React.useState(null)
	const dispatch = useDispatch()

const handleCreate = async ()=>{
	try{
		if (isInfo) {
			if (name !== '' && description !== '' && level !== '') {
				setIsInfo(false)
				setIsPart(true)
				setIsNext(true)
                setProgress(30)
			} else {
				setMessage("please, fill all the form")
				setOpen(true)
			}
		} else if(isPart) {
			setIsPart(false)
			setIsSend(true)
			setIsNext(true)
            setProgress(50)
		}else{

			const get_mom = handleDiff().start_mom
			const end_mom = handleDiff().end_mom
			const get_dur = handleDiff().diff

			let sect_dur = 0

			for (let i = 0; i < sections.length; i++) {
				sect_dur += sections[i].duration
				
			}

			if (parseInt(get_dur) >= sect_dur) {
				
				const data = {
					id:generate_id(),
					name:name,
					type:type,
					category:category,
					email:user?.email,
					description:description,
					start_date:start_date,
					start_moment:get_mom,
					end_moment:end_mom,
					visibility:visible_type,
					time:parseInt(get_dur),
					level:level,
					users:[
					{
						email:user?.email,
						last_name:user?.last_name,
						first_name:user?.first_name,
						hasTook:false,
						hasFinished:false,
						data:[]
					},
					...participants
					],
					reports:[],
					sections:[...sections]
				}
	
				const token = user?.accessToken
	
				// console.log(data)
	
				create_template(dispatch,token,templates,add_template,add_templates,setOpen,setMessage,data,setLoading,navigate)
			
			} else {
				setMessage(`Please,make sure the time that will take all your sections do not exceed ${parseInt(get_dur)} min !`)
				setOpen(true)
			}
		}

	}catch(err){
		console.log(err)
	}
}

// async function addData (newData){
// 	const getData = await localStorage.getItem("activities")

// 	if(getData){
// 		const parseData = JSON.parse(getData)

// 		if (parseData.length === 4) {
// 			const updatedData = [...parseData.slice(1), newData]; 
// 			dispatch(add_activities(updatedData))
// 			dispatch(add_activity(newData))
// 			localStorage.setItem("activities",JSON.stringify(updatedData))
// 		} else { 
// 			dispatch(add_activities([newData, ...JSON.parse(getData)]))
// 			dispatch(add_activity(newData))
// 			localStorage.setItem("activities",JSON.stringify([newData, ...parseData]))
// 		}

// 	}else{
// 		dispatch(add_activities([newData]))
// 		localStorage.setItem("activities",JSON.stringify([newData]))
// 	}
// }

const handleAdd = ()=>{
	try{
		if (first_name !== "" && last_name !== "" && email !== "") {
			const data = {
				first_name:first_name,
				last_name:last_name,
				email:email,
				hasTook:false,
				hasFinished:false,
				isDisqualified:false,
				data:[]
			}
		
		const newData = [...participants,data]
	
		setParticipants(newData)
		setFirst_name("")
		setLast_name("")
		setEmail("")

		} else {
			setMessage("You have to fill all the form to add")
			setOpen(true)
		}

	}catch(err){
		console.log(err)
	}
}

const handleDiff = ()=>{
	const diff = dayjs(duration).diff(start_moment, 'minute');
	const start_mom = dayjs(start_moment).format("HH:mm");
	const end_mom = dayjs(duration).format("HH:mm");
	return {diff,start_mom,end_mom}
}

const handleSnackbarClose = ()=>{
	setOpen(false)
}

	return(
		<Box sx={{minWidth:{xs:400,md:700}}}>
			<Header title="Create Assessment">
				<Breadcrumbs aria-label="breadcrumb">
					<Link  sx={{fontSize:12,color:"gray"}} underline="hover" color="inherit" href="/dashboard">
						Dashboard
					</Link>
					<Typography sx={{fontSize:12,color:"gray"}}>Duplicate/template</Typography>
			</Breadcrumbs>			
			</Header>
			<Container>
				<Snackbar 
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}} 
					message={message} 
					onClose={handleSnackbarClose} 
					open={open} 
					autoHideDuration={2000}
				/>
                <BorderLinearProgress variant="determinate" value={progress} />
				<Box m={2} sx={{backgroundColor:"black",borderRadius:5,padding:2,width:'100%'}}>
					<Typography mt={1} mb={1} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
						Add Template Detail
					</Typography>
					<Box m={1} display="flex" width="90%" flexDirection="row" justifyContent="space-between" alignItems="center">
						{
						isPart && (
							<Box  display="flex"flexDirection="row" justifyContent="space-between" alignItems="center">
							<Typography style={{fontSize:15,fontWeight:400}}>
								{participants.length}
							</Typography>
								<IconButton onClick={(e)=>{
									e?.preventDefault()
									setShowDialog(true)
								}} sx={{borderRadius:2,height:25}}>
									<PeopleAltOutlined/>
								</IconButton>								
							</Box>

						)
						}
						<Box  display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" width="10%">
							{
								isSend && (
									<Box  display="flex"flexDirection="row" justifyContent="space-between" alignItems="center">
										<IconButton onClick={(e)=>{
											e?.preventDefault()
											setShowSections(true)
										}} sx={{borderRadius:2,height:25}}>
											<Typography style={{fontSize:15,fontWeight:400}}>
												{sections.length}
											</Typography>
											<FilePresentOutlined/>
										</IconButton>								
									</Box>
								)
							}
					</Box>
						<Typography m={1} style={{fontSize:13,color:"#ff0",fontFamily:"dinofans"}}>
							{
								isInfo ? "Assessment Info" : isPart ? "Participant Detail" : "Assessment Sections"
							}
						</Typography>
						{
						isNext && (
							<IconButton sx={{borderRadius:2,height:25}} onClick={()=>{
								if(isSend){
									setIsSend(false)
									setIsPart(true)
								}else if(isPart){
									setIsPart(false)
									setIsInfo(true)
								}else{
									setIsNext(false)
								}
								
							}}>
								<ArrowIcon />
							</IconButton>
						)}
					</Box>
					{
						isSend && (
							<Divider/>
						)
					}
					{
					isInfo && (
						<GridViewContainer>
							<UserInput
								label="Title *"
								isPass={false}
								input={name}
								setInput={setName}
							>
								<FormatAlignCenter/>
							</UserInput>
							<UserInput
								label="Start date *"
								isDate={true}
								input={start_date}
								isPass={false}
								setInput={setStart_date}
							>
								<FormatAlignCenter/>
							</UserInput>
							<TimeInput
								label="start moment"
								input={start_moment}
								setInput={setStart_moment}
							/>
							<TimeInput
								label="End Moment *"
								input={duration}
								setInput={setDuration}
							/>
							<AutoInput
								data={response_types}
								setInput={setType}
								input={type}
								label="Type"
							/>
							<AutoInput
								data={categories}
								setInput={setCategory}
								input={category}
								label="Category"
							/>
							<AutoInput
								data={levels}
								setInput={setLevel}
								input={level}
								label="level"
							/>
							<AutoInput
								data={types}
								setInput={setVisible_type}
								input={visible_type}
								label="visibility"
							/>
							<Box width="95%">
								<EditorText 
									title="Assessment description"
									data={description}
									setData={setDescription}
									width="95%"
									label="description"
									isRequired={true}
								/>
							</Box>
						</GridViewContainer>
						)
					}
					{
					isSend && (
						<SectionAddView setSections={setSections} level={level} lang={lang} response_type={response_type} setResponse_type={setResponse_type} />
					)}
					{
					isPart && (
						<GridViewContainer>
							<UserInput
								label="Participant first name"
								isPass={false}
								input={first_name}
								setInput={setFirst_name}
							>
								<AccountCircle/>
							</UserInput>
							<UserInput
								label="Participant last name"
								input={last_name}
								isPass={false}
								setInput={setLast_name}
							>
								<AccountCircle/>
							</UserInput>
							<UserInput
								label="Participant email"
								input={email}
								isPass={false}
								setInput={setEmail}
							>
								<AccountCircle/>
							</UserInput>
							<Button sx={{background:"gold",color:"black",marginTop:2,marginLeft:{sm:3,md:0},height:{xs:30,md:35},fontFamily:"dinofans"}} onClick={handleAdd} variant="contained">
								Add
							</Button>
						</GridViewContainer>
						)}
						<Divider/>
						<Button sx={{background:"maroon",color:"#fff",fontFamily:"dinofans",fontSize:12,marginTop:2}} disabled={loading ? true : false} onClick={handleCreate} >
							{
								isSend && loading ? <CircularProgress size={20} style={{color:"#fff"}}/> : isSend && !loading  ? "CREATE TEMPLANTE" : "NEXT"
							}
						</Button>
				</Box>
				<CustomDialog handleUserDelete={(email)=>{
					const filterData = participants?.filter(item=>item?.email !== email)
					setParticipants(filterData)
                }} data={participants} visible={showDialog} setVisible={setShowDialog}/>
                <SectionsDialog setData={setSections} data={sections} visible={showSections} setVisible={setShowSections}/>
			</Container>
		</Box>
		)
}

export default DuplicateTemplate